const defaultAccept = ['.pdf', '.jpg', '.png', '.jpeg', '.doc', '.docx', '.xls', '.xlsx', '.html', '.msg', '.eml', '.zip'];

export default defaultAccept;
